import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from "moment"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import PopUp from "@/components/PopUp";
Vue.component("PopUp", PopUp)
import PageTable from "@/components/page-table/PageTable.vue";
Vue.component("PageTable", PageTable)
import HeaderTitle from "@/components/HeaderTitle.vue";
Vue.component("HeaderTitle", HeaderTitle)
import HeaderGoBack from "@/components/HeaderGoBack.vue";
Vue.component("HeaderGoBack", HeaderGoBack)
import Pagination from "@/components/Pagination.vue"
Vue.component("Pagination", Pagination)



Vue.use(ElementUI, { size: 'small' })
Vue.use(VueAxios, axios)

Vue.prototype.moment = moment;
Vue.prototype.bus = new Vue();

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
